<template>
  <v-layout row justify-center>
    <v-dialog v-model="editorOpen" persistent max-width="600px">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="translation.name"
                  :placeholder="$t('fieldNamePlaceHolder')"
                  :rules="[rules.required, rules.maxLength]"
                  counter="255"
                  required
                  :label="$t('fieldNameLabel')"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="[
                    {
                      text: $t('itemFrench'),
                      value: 'fr_FR',
                    },
                    {
                      text: $t('itemEnglish'),
                      value: 'en_GB',
                    },
                    {
                      text: $t('itemGerman'),
                      value: 'de_DE',
                    },
                    {
                      text: $t('itemNL'),
                      value: 'nl_NL',
                    },
                    {
                      text: $t('itemItalian'),
                      value: 'it_IT',
                    },
                    {
                      text: $t('itemSpanish'),
                      value: 'es_ES',
                    },
                    {
                      text: $t('itemPortuguese'),
                      value: 'pt_PT',
                    }]"
                  menu-props="auto"
                  :label="$t('fieldLangLabel')"
                  v-model="translation.locale"
                  hide-details
                />
              </v-col>
              <v-col cols="12" v-if="includeDescription === true">
                <vue-editor
                  v-model="translation.description"
                  :placeholder="$t('fieldDescriptionPlaceholder')"
                  :editorToolbar="customToolbar"
                  id="description-editor"
                />
              </v-col>
            </v-row>
          </v-container>
          <small>{{ $t('textMandatoryFields') }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="$emit('closeclicked')">
            {{ $t('btnCancel')}}
          </v-btn>
          <v-btn
            color="secondary"
            :disabled="!translationIsValid"
            text
            @click="save">{{ $t('btnSave') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import validator from '../../services/validation';

export default {
  components: { VueEditor },
  props: {
    initialTranslation: {
      type: Object,
      required: false,
      default: () => ({
        id: 0,
        locale: 'fr_FR',
        name: '',
        description: '',
        uuid: '',
      }),
    },
    includeDescription: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      customToolbar: [
        [
          'bold',
          'italic',
          'underline',
          { list: 'ordered' },
          { list: 'bullet' },
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { header: [1, 2, 3, false] },
        ],
      ],
      editorOpen: true,
      translation: {
        id: this.initialTranslation.id,
        name: this.initialTranslation.name,
        description: this.initialTranslation.description,
        locale: this.initialTranslation.locale,
        uuid: this.initialTranslation.uuid,
      },
      rules: {
        required: (value) => !!value || this.$t('errorEmptyField'),
        maxLength: (value) => validator.ValidateMaxLength(value, 255) || this.$t('errorTooLong'),
      },
    };
  },
  computed: {
    translationIsValid() {
      if (
        this.rules.required(this.translation.name) === true
        && this.rules.maxLength(this.translation.name, 255) === true
      ) {
        return true;
      }
      return false;
    },
    title() {
      if (this.initialTranslation.name !== '') {
        return this.$t('pageTitleEdit');
      }
      return this.$t('pageTitleCreate');
    },
  },
  methods: {
    save() {
      if (!this.translationIsValid) {
        return;
      }
      this.$emit('savetranslation', this.translation);
    },
  },
};
</script>
<i18n>
{
  "fr": {
    "itemFrench": "Français",
    "itemEnglish": "Anglais",
    "itemGerman": "Allemand",
    "itemNL": "Néerlandais",
    "itemItalian": "Italien",
    "itemSpanish": "Espagnol",
    "itemPortuguese": "Portugais",
    "fieldNamePlaceholder": "Titre*",
    "fieldNameLabel": "Titre*",
    "fieldLangLabel": "Langue*",
    "fieldDescriptionPlaceholder": "Description*",
    "textMandatoryFields": "*Champs obligatoires",
    "btnCancel": "Annuler",
    "btnSave": "Enregistrer",
    "pageTitleEdit": "Modifier une traduction",
    "pageTitleCreate": "Créer une traduction",
    "errorEmptyField": "Ce champ ne peut pas être vide.",
    "errorTooLong": "Nom trop long"
  },
  "en": {
    "itemFrench": "French",
    "itemEnglish": "English",
    "itemGerman": "German",
    "itemNL": "Dutch",
    "itemItalian": "Italian",
    "itemSpanish": "Spanish",
    "itemPortuguese": "Portuguese",
    "fieldNamePlaceholder": "Title*",
    "fieldNameLabel": "Title*",
    "fieldLangLabel": "Language*",
    "fieldDescriptionPlaceholder": "Description*",
    "textMandatoryFields": "*Mandatory fields",
    "btnCancel": "Cancel",
    "btnSave": "Save",
    "pageTitleEdit": "Edit a translation",
    "pageTitleCreate": "Create a translation",
    "errorEmptyField": "This field cannot be empty",
    "errorTooLong": "Name too long"

  }
}
</i18n>
